import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  ScrollView,
  Dimensions,
  PixelRatio,
  ActivityIndicator,
  Platform,
} from "react-native";
import React, { useEffect, useMemo, useState } from "react";
import Colours from "../../utils/Colours";
// import { Colors } from "react-native/Libraries/NewAppScreen";
import { useNavigation } from "@react-navigation/native";
import useAuth from "../../hooks/useAuth";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import ProfileScreen from "../profileScreen/ProfileScreen";
import WalletBalanceScreen from "../wallet/WalletBalanceScreen";
import VerifiedCustomer from "../wallet/VerifiedCustomer";
import WalletScreen from "../wallet/WalletScreen";
import MeezaCreditScreen from "../wallet/MeezaCreditScreen";
import TransactionCodeSetUpScreen from "../transactionDigitCode/TransactionCodeSetUpScreen";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import TutorialTables from "../../alertComp/TutorialTables";
import TutorialPulls from "../../alertComp/TutorialPulls";

import { getItem, saveItem, deleteItem } from "../../utils/secureStorage";

import WalletIcons from "../../icons/WalletIcons";
import meezalogo from "../../../assets/MeRed.jpg";
import MoneyIcon from "../../icons/MoneyIcon";
import WordNotice from "../../alertComp/WordNotice";
import { Image } from "expo-image";
import IdeaLamp from "../../icons/IdeaLamp";
import { navigate } from "expo-router/build/global-state/routing";
import { Ionicons } from "@expo/vector-icons";
import { useQuery } from "@tanstack/react-query";

const { width, height } = Dimensions.get("window");
const dpr = PixelRatio.get();
const VAL_NAME = "dxfdmlk0f";
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

const Fonts = {
  small: width * 0.03, // ~12px
  medium: width * 0.04, // ~16px
  large: width * 0.05, // ~20px
};

const dynamicThumbnailWidth = Math.round(width * 0.12);
const dynamicThumbnailHeight = Math.round(width * 0.12);

// const yourRecentTablesArray = [
//   {
//     id: "table-01",
//     tableName: "OBO Table",
//     brandName: "Club Cubana Lounge",
//     createdAt: new Date(Date.now() - 15 * 60 * 1000).toISOString(), // 15 mins ago
//   },
//   {
//     id: "table-02",
//     tableName: "VVIP Section 3",
//     brandName: "Quilox Club & Bar",
//     createdAt: new Date(Date.now() - 40 * 60 * 1000).toISOString(), // 40 mins ago
//   },
// ];

/**
 * Custom hook to check if a timestamp is within the last 10 minutes.
 * Re-evaluates every 10 seconds and forces a update when the limit is crossed.
 */
export function useIsRecentlyCreated(createdAtString, limitMinutes = 10) {
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (!createdAtString) return;

    const createdTime = new Date(createdAtString).getTime();
    const limitMs = limitMinutes * 60 * 1000;

    const checkValidity = () => {
      const now = Date.now();
      const difference = now - createdTime;
      const withinLimit = difference >= 0 && difference < limitMs;
      setIsValid(withinLimit);
    };

    // Initial check
    checkValidity();

    // Check every 10 seconds to auto-vanish the tag gracefully
    const interval = setInterval(checkValidity, 10000);

    return () => clearInterval(interval);
  }, [createdAtString, limitMinutes]);

  return isValid;
}
// ==========================================
// INDIVIDUAL TABLE ROW COMPONENT
// ==========================================
// const TableSlimRowItem = ({ table, index, handleOpenTable }) => {
//   // Hooks are now safely called at the top level of a single component!
//   const tableCreatedAt = table.createdAt;
//   // 2. Find the latest paid order timestamp from the orders array
//   let lastPaidOrderTime = null;

//   if (table.orders && table.orders.length > 0) {
//     // Filter only orders that are strictly paid and have a paidAt timestamp
//     const paidOrders = table.orders.filter((order) => order.status === "paid" && order.paidAt);

//     if (paidOrders.length > 0) {
//       // Find the absolute newest paidAt date in the array
//       const latestOrder = paidOrders.reduce((latest, current) => {
//         return new Date(current.paidAt) > new Date(latest.paidAt) ? current : latest;
//       });
//       lastPaidOrderTime = latestOrder.paidAt;
//     }
//   }

//   const isNewTable = useIsRecentlyCreated(tableCreatedAt);
//   const isRecentTopUp = useIsRecentlyCreated(lastPaidOrderTime);

//   const showTopUpTag = isRecentTopUp;
//   const showNewTableTag = isNewTable && !isRecentTopUp;

//   return (
//     <View key={table._id || table.id || index} style={styles.tableSlimRow}>
//       <View style={styles.tableMetaBlock}>
//         <Text style={styles.slimTableName} numberOfLines={1}>
//           {table.tableName || "OBO Table"}
//         </Text>
//         {/* ICON & BRAND NAME CONTAINER */}
//         <View style={{ flexDirection: "row", alignItems: "center", marginTop: 2 }}>
//           <Ionicons
//             name="location-outline"
//             size={dynamicSize(12)}
//             color="gray"
//             style={{ marginRight: 4 }}
//           />
//           <Text style={[styles.slimBrandName, { marginTop: 0 }]} numberOfLines={1}>
//             {table.associatedBrand?.brandName || table.brandName || "Club Venue / Lounge"}
//           </Text>
//         </View>
//       </View>

//       {/* RIGHT ACTION CONTAINER */}
//       <View style={{ flexDirection: "row", alignItems: "center", gap: dynamicSpacing(8) }}>
//         {/* TOP-UP SUCCESSFUL STATUS TAG */}
//         {showTopUpTag && (
//           <View style={styles.statusContainer}>
//             <View style={[styles.statusDot, { backgroundColor: "#27AE60" }]} />
//             <Text style={[styles.statusText, { color: "#27AE60" }]}>Top up Successful</Text>
//           </View>
//         )}

//         {/* NEWLY CREATED SUCCESSFUL STATUS TAG */}
//         {showNewTableTag && (
//           <View style={styles.statusContainer}>
//             <View style={[styles.statusDot, { backgroundColor: "#27AE60" }]} />
//             <Text style={[styles.statusText, { color: "#27AE60" }]}>Successful</Text>
//           </View>
//         )}

//         {/* VIEW & PAY BUTTON */}
//         <TouchableOpacity style={styles.slimCheckBillBtn} onPress={() => handleOpenTable(table)}>
//           <Text style={styles.slimCheckBillBtnText}>View table</Text>
//           <Ionicons name="chevron-forward" size={dynamicSize(15)} color="white" />
//         </TouchableOpacity>
//       </View>
//     </View>
//   );
// };

const TableSlimRowItem = ({ table, index, handleOpenTable }) => {
  const tableCreatedAt = table.createdAt;

  // Find the latest order by orderedAt, regardless of whether it's paid or pending (pay later)
  const allOrders = table.orders || [];

  const latestOrder =
    allOrders.length > 0
      ? allOrders.reduce((latest, current) =>
          new Date(current.orderedAt) > new Date(latest.orderedAt) ? current : latest,
        )
      : null;

  const lastOrderTime = latestOrder?.orderedAt || null;

  const isNewTable = useIsRecentlyCreated(tableCreatedAt);
  const isRecentOrder = useIsRecentlyCreated(lastOrderTime);

  // Trust the backend's isTopUp flag on the latest order (works for both pay-now and pay-later)
  const showTopUpTag = isRecentOrder && latestOrder?.isTopUp === true;

  // Show "Successful" if the table itself is new, as long as the recent activity wasn't a top-up
  const showNewTableTag = isNewTable && !showTopUpTag;
  console.log("allOrdersss", allOrders);

  const hasUnpaidOrders = allOrders.some((order) => order.status === "pending");

  return (
    <View key={table._id || table.id || index} style={styles.tableSlimRow}>
      <View style={styles.tableMetaBlock}>
        <Text style={styles.slimTableName} numberOfLines={1}>
          {table.tableName || "OBO Table"}
        </Text>
        {/* ICON & BRAND NAME CONTAINER */}
        <View style={{ flexDirection: "row", alignItems: "center", marginTop: 2 }}>
          <Ionicons
            name="location-outline"
            size={dynamicSize(12)}
            color="gray"
            style={{ marginRight: 4 }}
          />
          <Text style={[styles.slimBrandName, { marginTop: 0 }]} numberOfLines={1}>
            {table.associatedBrand?.brandName || table.brandName || "Club Venue / Lounge"}
          </Text>
        </View>
      </View>

      {/* RIGHT ACTION CONTAINER */}
      <View style={{ flexDirection: "row", alignItems: "center", gap: dynamicSpacing(8) }}>
        {/* TOP-UP SUCCESSFUL STATUS TAG */}
        {showTopUpTag && (
          <View style={styles.statusContainer}>
            <View style={[styles.statusDot, { backgroundColor: "#27AE60" }]} />
            <Text style={[styles.statusText, { color: "#27AE60" }]}>Top up Successful</Text>
          </View>
        )}

        {/* NEWLY CREATED SUCCESSFUL STATUS TAG */}
        {showNewTableTag && (
          <View style={styles.statusContainer}>
            <View style={[styles.statusDot, { backgroundColor: "#27AE60" }]} />
            <Text style={[styles.statusText, { color: "#27AE60" }]}>Successful</Text>
          </View>
        )}

        {/* VIEW & PAY BUTTON */}
        <TouchableOpacity style={styles.slimCheckBillBtn} onPress={() => handleOpenTable(table)}>
          <Text style={styles.slimCheckBillBtnText}>
            {hasUnpaidOrders ? "View & Pay" : "View & track order"}
          </Text>{" "}
          <Ionicons name="chevron-forward" size={dynamicSize(15)} color="white" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default function Header({ yourRecentTablesArray = [], isLoadingTables = false }) {
  const [createTableColor, setCreateTableColor] = useState(Colours.PRIMARY);
  const [joinTableColor, setJoinTableColor] = useState("#E8E8E8");
  const [createTxtColor, setCreateTxtColor] = useState("white");
  const [joinTxtColor, setJoinTxtColor] = useState(Colours.DARKGRAY);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showLovelyWeekend, setShowLovelyWeekend] = useState(false);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showUserProfilePage, setShowUserProfilePage] = useState(false);
  const [showMeezaCreditScreen, setShowMeezaCreditScreen] = useState(false);
  const [showTransactionCodeSetUp, setShowTransactionCodeSetUp] = useState(false);

  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  //  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
  const [errorMessage, setErrorMessage] = useState("");
  //   const [successMessage, setSuccessMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false);

  const [hasSeenCreateNotice, setHasSeenCreateNotice] = useState(false);
  const [hasSeenPullNotice, setHasSeenPullNotice] = useState(false);

  const [hideTablesButton, setHideTablesButton] = useState(true);

  const [showWordNotice, setShowWordNotice] = useState(false);
  const [wordMessage, setWordMessage] = useState(
    "Here’s your Celebratory tag! Copy and share it on other social media platforms — links in bio, posts, or status updates — to get celebrated.",
  );

  const [showWalletScreen, setShowWalletScreen] = useState(false);

  const [showVerifiedCustomer, setShowVerifiedCustomer] = useState(false);
  const [showWalletBalanceScreen, setShowWalletBalanceScreen] = useState(false);
  const [showTutorialTables, setShowTutorialTables] = useState(false);
  const [showTutorialPulls, setShowTutorialPulls] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [dvaStatus, setDVAStatus] = useState(false);
  const [celebrateMeLink, setCelebrateMeLink] = useState("");
  //  const [hasDVA, setHasDva] = useState(false)

  const [retryCount, setRetryCount] = useState(0);

  const [imageKey, setImageKey] = useState(0);

  // const [errorMessage, setErrorMessage] = useState('')
  //console.log()
  const navigation = useNavigation();

  const axiosPrivate = useAxiosPrivate();

  const {
    sub,
    username,
    firstname,
    lastname,
    phonenumber,
    email,
    image,
    isEmailVerified,
    activitySettings,
    isVerifiedForPayment,
    hasDVA,
  } = useAuth();

  useEffect(() => {
    // Clear the monnify redirect flag only when running on Web/Browser
    if (Platform.OS === "web" && typeof sessionStorage !== "undefined") {
      sessionStorage.removeItem("monnify_redirected");
    }
  }, []);

  useEffect(() => {}, [hasDVA, isVerifiedForPayment, isEmailVerified]);

  useEffect(() => {
    setCelebrateMeLink(`getmeeza.com/u/${username}`);
  }, [username]);

  useEffect(() => {
    const checkCreateNotice = async () => {
      //const seen = await SecureStore.getItemAsync("hasSeenCreateNotice");
      const seen = await getItem("hasSeenCreateNotice");

      if (seen === "true") {
        setHasSeenCreateNotice(true);
      }
    };
    checkCreateNotice();
  }, []);

  useEffect(() => {
    const checkPullNotice = async () => {
      //const seen = await SecureStore.getItemAsync("hasSeenPullNotice");
      const seen = await getItem("hasSeenPullNotice");
      if (seen === "true") {
        setHasSeenPullNotice(true);
      }
    };
    checkPullNotice();
  }, []);

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    ////console.log('topHeader', targetHeight)
    ////console.log('topHeaderW', targetWidth)

    // The 'transformations' string includes the optimization flags
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    // Inject the transformations into the URL
    return originalUrl.replace(/upload\//, `upload/${transformations}/`);
  };

  // 2. Optimize the thumbnail image
  const userImageThumbnailUrl = getOptimizedCloudinaryUrl(
    image,
    dynamicThumbnailWidth,
    dynamicThumbnailHeight,
  );

  const handleCreateTableClick = async () => {
    // const hasSeenNotice = await SecureStore.getItemAsync("hasSeenCreateNotice");
    const hasSeenNotice = await getItem("hasSeenCreateNotice");

    if (!hasSeenNotice) {
      setShowTutorialTables(true);
    } else {
      proceedWithCreateTable();
    }
  };

  const handleCreatePullClick = async () => {
    //const hasSeenPullNotice = await SecureStore.getItemAsync("hasSeenPullNotice");
    const hasSeenPullNotice = await getItem("hasSeenPullNotice");

    if (!hasSeenPullNotice) {
      setShowTutorialPulls(true);
    } else {
      proceedWithCreatePull();
    }
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      ////console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      //console.error('Image failed to load after maximum retries.');
    }
  };

  const handleCheckMyBill = () => {
    //navigation.navigate("checkMyBill");
    navigation.navigate("checkMyBill");
  };

  const proceedWithCreateTable = () => {
    if (createTableColor === Colours.PRIMARY) {
      setCreateTableColor(Colours.PRIMARY);
      setCreateTxtColor("white");

      //setShowCreateModal(true);
      navigation.navigate("create_a_bid_table");

      //setShowLovelyWeekend(true); //CHANGED BUT COULD BE REVIEWED

      //setShowTutorialTables(true)
      //  setJoinTableColor('#E8E8E8')
    } else {
      // setShowCreateModal(true);
      navigation.navigate("create_a_bid_table");

      setCreateTableColor(Colours.PRIMARY);
      setCreateTxtColor("white");
      setJoinTableColor("#E8E8E8");
      setJoinTxtColor(Colours.DARKGRAY);
      // setCreateTableColor(createTableColor === Colours.PRIMARY ? Colours.PRIMARY : '#E8E8E8' );
    }
  };

  const proceedWithCreatePull = () => {
    if (joinTableColor === Colours.PRIMARY) {
      setJoinTableColor(Colours.PRIMARY);
      setJoinTxtColor("white");
      setShowJoinModal(true);

      // setCreateTableColor('#E8E8E8')
    } else {
      setShowJoinModal(true);
      setJoinTableColor(Colours.PRIMARY);
      setJoinTxtColor("white");
      setCreateTableColor("#E8E8E8");
      setCreateTxtColor(Colors.DARKGRAY);
    }
  };

  const handleProfile = () => {
    //setShowUserProfilePage(true);
    navigation.navigate("profile");
  };

  const handleWalletScreen = async () => {
    // const hasDVA = dvaStatus
    ////console.log('hasDVAxy', hasDVA)
    ////console.log('isVerifiedForPaymentuu', isVerifiedForPayment)

    if ((hasDVA || dvaStatus) && isVerifiedForPayment) {
      // setShowWalletScreen(true)
      ////console.log('hasDVAxx')
      setShowWalletBalanceScreen(true);
    } else if ((hasDVA || dvaStatus) === false && isVerifiedForPayment === true) {
      ////console.log('isVerified')
      setShowVerifiedCustomer(true);
    } else if ((hasDVA || dvaStatus) === false && isVerifiedForPayment === false) {
      ////console.log('no dva and not verified')
      setShowWalletScreen(true);
    }
  };

  const handleBioUpdatePage = async () => {
    navigation.navigate("bio_update");
  };

  // const handleCreditScreen = () => {
  //   ////console.log('Email Verified', isEmailVerified)
  //   if (isEmailVerified || isVerified) {
  //     handleCheckForPassCode();
  //   } else {
  //     setErrorMessage(
  //       "Please click the Buy button to verify your email | click the Credit button to setup your four digit transaction code",
  //     );
  //     setIsErrorCompVisible(true);
  //   }
  // };
  const handleCreditScreen = () => {
    setErrorMessage("Your  DoingsCRED is still on the rise");
    setIsErrorCompVisible(true);
  };

  const handleCheckForPassCode = async () => {
    //check if user has set passcode or not
    try {
      setIsLoading(true);
      const response = await axiosPrivate.get("/isPasscode/isPasscode");
      if ((response.status === 200 || response.status === 201) && response.data?.hasPasscode) {
        ////console.log('PASSCODE:', response.data?.hasPasscode)
        //setShowMeezaCreditScreen(true);
        navigation.navigate("meezaCreditScreen");
      } else {
        // setShowTransactionCodeSetUp(true);
        navigation.navigate("transactionCodeSetup");
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
        const errorMessages =
          error.response.data?.error || error.response.data?.message || "Something went wrong";
        setErrorMessage(errorMessages);
        setIsErrorCompVisible(true);
      }
    } finally {
      setIsLoading(false);
    }

    // setShowMeezaCreditScreen(true)
    // setShowTransactionCodeSetUp(true)
  };

  const updateCustomer = async () => {
    //  setIsLoading(true)

    const response = await axiosPrivate.post("/updateCustomer/updateCustomer");
    ////console.log('responseUpdateCustor', response)
  };

  // Clears both disk and memory caches
  const clearImageCache = async () => {
    try {
      await Image.clearDiskCache();
      await Image.clearMemoryCache();
      ////console.log('Image cache cleared successfully');
    } catch (error) {
      //console.error('Error clearing cache:', error);
    }
  };

  const handleOpenTable = (selectedTable) => {
    //console.log("SELECTED ITEMMM", selectedTable, "MODE:");
    navigation.navigate("a_Doing", {
      selectedTable,
      mode: "activeTables",
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.profileCelebrateMe}>
        <TouchableOpacity style={styles.profileContainer} onPress={handleProfile}>
          {image ? (
            <Image
              key={imageKey}
              source={{ uri: userImageThumbnailUrl }}
              style={[styles.userImage, { backgroundColor: "#d6d4d4ff" }]}
              contentFit="cover"
              cachePolicy="disk"
              onError={handleImageError}
            />
          ) : (
            <Image
              source={require("../../../assets/profile_image_holder.jpg")}
              style={styles.userImage}
            />
          )}
          <View>
            <Text style={styles.welcomeText}>Welcome</Text>
            <Text style={styles.nameText}>{username}</Text>
            {/* <Text style={styles.nameText2}>{firstname} {lastname}</Text> */}
          </View>
        </TouchableOpacity>
        {/* <TouchableOpacity
          style={styles.celebrateMeStyles}
          onPress={() => {
            //  clearImageCache()
            setShowWordNotice();
          }}
        >
          <Text style={styles.welcomeText}>Celebrate</Text>
          <Image
            source={meezalogo}
            style={{
              width: dynamicSize(20),
              height: dynamicSize(20),
              borderRadius: dynamicSize(6),
              // boxShadow isn't supported directly in React Native.
              // Instead, use shadow props (iOS) + elevation (Android):
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 4 },
              shadowOpacity: 0.25,
              shadowRadius: 10,
              elevation: 5,
              resizeMode: "cover",
            }}
          />
        </TouchableOpacity> */}
      </View>

      <View style={styles.transferFromContainer}>
        <View style={styles.transferFromTextContainer}>
          <Text style={styles.quickAccessText}>{"        "}</Text>
        </View>

        <View style={styles.topUpButtons}>
          <TouchableOpacity
            style={styles.fab6}
            // onPress={handleWalletScreen}
            onPress={() => {
              // setShowMyBrands(true);
              navigation.navigate("business_page");
            }}
          >
            <View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <IdeaLamp color="white" height={dynamicSize(25)} width={dynamicSize(30)} />
              {/* <Text style={styles.topUpButtonText}>Wallet</Text> */}
              <Text style={styles.topUpButtonText}>Brands</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.fab1}
            // onPress={handleWalletScreen}
            // onPress={handleBuyMeezaCredits}
            onPress={handleBioUpdatePage}
          >
            <View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Ionicons name="document-text-outline" size={dynamicSize(25)} color="white" />
              {/* <Text style={styles.topUpButtonText}>Wallet</Text> */}
              {/* <Text style={styles.topUpButtonText}>Buy</Text> */}
              <Text style={styles.topUpButtonText}>Bio</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.fab}
            onPress={handleCreditScreen}

            // navigation.navigate("business_page");
          >
            {isLoading ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <>
                <MoneyIcon color="white" height={dynamicSize(25)} width={dynamicSize(30)} />
                <Text style={styles.topUpButtonText}> CRED </Text>
              </>
            )}
          </TouchableOpacity>
        </View>
      </View>

      <View style={styles.buttonContainer2}>
        {/* <TouchableOpacity style={styles.button} onPress={proceedWithCreateTable}>
          <Text style={styles.buttonText}>{"Create a Virtual Table"}</Text>
        </TouchableOpacity> */}
        {/* <TouchableOpacity style={styles.button} onPress={handleTableTopup}>
          <Text style={styles.buttonText}>{"Top-up your Table "}</Text>
        </TouchableOpacity> */}
        {/* <TouchableOpacity style={styles.button} onPress={handleCheckMyBill}>
          <Text style={styles.buttonText}>{"Check my bill "}</Text>
        </TouchableOpacity> */}
      </View>
      {/* --- RECENT ACTIVE TABLES LIST SECTION --- */}
      {/* Only render this section if it's currently loading, OR if there is actual table data to display */}
      {(isLoadingTables || (yourRecentTablesArray && yourRecentTablesArray.length > 0)) && (
        <View style={styles.activeTablesSection}>
          <Text style={styles.sectionHeadingText}>YOUR ACTIVE TABLES</Text>

          {isLoadingTables ? (
            <ActivityIndicator
              size="small"
              color={Colours.PRIMARY}
              style={{ marginVertical: dynamicSpacing(10) }}
            />
          ) : (
            // yourRecentTablesArray.map((table, index) => {
            //   const isNewTable = useIsRecentlyCreated(table.createdAt);

            //   // 2. Check if a top-up occurred in the last 10 minutes
            //   const isRecentTopUp = useIsRecentlyCreated(table.lastTopUpAt);
            //   // Determine which text to show (prioritize the top-up tag if both are active)
            //   const showTopUpTag = isRecentTopUp;
            //   const showNewTableTag = isNewTable && !isRecentTopUp;
            //   return (
            //     <View key={table._id || table.id || index} style={styles.tableSlimRow}>
            //       <View style={styles.tableMetaBlock}>
            //         <Text style={styles.slimTableName} numberOfLines={1}>
            //           {table.tableName || "OBO Table"}
            //         </Text>
            //         {/* ICON & BRAND NAME CONTAINER */}
            //         <View style={{ flexDirection: "row", alignItems: "center", marginTop: 2 }}>
            //           <Ionicons
            //             name="location-outline"
            //             size={dynamicSize(12)}
            //             color="gray"
            //             style={{ marginRight: 4 }}
            //           />
            //           <Text style={[styles.slimBrandName, { marginTop: 0 }]} numberOfLines={1}>
            //             {table.associatedBrand?.brandName ||
            //               table.brandName ||
            //               "Club Venue / Lounge"}
            //           </Text>
            //         </View>
            //       </View>

            //       {/* RIGHT ACTION CONTAINER */}
            //       <View
            //         style={{ flexDirection: "row", alignItems: "center", gap: dynamicSpacing(8) }}
            //       >
            //         {/* RENDER TOP-UP TAG */}
            //         {showTopUpTag && (
            //           <View style={styles.statusContainer}>
            //             <View style={[styles.statusDot, { backgroundColor: "#27AE60" }]} />
            //             <Text style={[styles.statusText, { color: "#27AE60" }]}>
            //               Top up Successful
            //             </Text>
            //           </View>
            //         )}

            //         {/* RENDER NEW TABLE TAG */}
            //         {showNewTableTag && (
            //           <View style={styles.statusContainer}>
            //             <View style={[styles.statusDot, { backgroundColor: "#27AE60" }]} />
            //             <Text style={[styles.statusText, { color: "#27AE60" }]}>Successful</Text>
            //           </View>
            //         )}

            //         {/* BUTTON */}
            //         <TouchableOpacity
            //           style={styles.slimCheckBillBtn}
            //           onPress={() => handleOpenTable(table)}
            //         >
            //           <Text style={styles.slimCheckBillBtnText}>View Table</Text>
            //           <Ionicons name="chevron-forward" size={dynamicSize(15)} color="white" />
            //         </TouchableOpacity>
            //       </View>
            //     </View>
            //   );
            // })
            yourRecentTablesArray.map((table, index) => (
              <TableSlimRowItem
                key={table._id || table.id || index}
                table={table}
                index={index}
                handleOpenTable={handleOpenTable} // Make sure this function is defined or passed in Header
              />
            ))
          )}
        </View>
      )}

      {/* <View style={styles.buttonContainer}>
        <TouchableOpacity
          style={[styles.button, { backgroundColor: createTableColor }]}
          onPress={proceedWithCreateTable}
        >
          <Text style={[styles.buttonText, { color: createTxtColor }]}>{"Create a Table"}</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.button, { backgroundColor: joinTableColor }]}
          onPress={proceedWithCreatePull}
        >
          <Text style={[styles.buttonText, { color: joinTxtColor }]}>{"Create a Pull"}</Text>
        </TouchableOpacity>
      </View> */}

      {/* <Modal
        animationType="slide"
        visible={showUserProfilePage}
        onRequestClose={() => setShowUserProfilePage(false)}
      >
        <TopHeaderComponent
          headerText={"My Profile"}
          hideScreen={() => setShowUserProfilePage(false)}
        />
        <ProfileScreen />
      </Modal> */}
      <Modal
        animationType="slide"
        visible={showMeezaCreditScreen}
        onRequestClose={() => setShowMeezaCreditScreen(false)}
      >
        <MeezaCreditScreen hideScreen={() => setShowMeezaCreditScreen(false)} />
      </Modal>

      <Modal
        animationType="slide"
        visible={showTransactionCodeSetUp}
        onRequestClose={() => setShowTransactionCodeSetUp(false)}
      >
        <TopHeaderComponent
          headerText={"Setup Transaction Code"}
          hideScreen={() => setShowTransactionCodeSetUp(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <TransactionCodeSetUpScreen hideScreen={() => setShowTransactionCodeSetUp(false)} />
        </ScrollView>
      </Modal>

      {/*No Longer used for wallet but used to setup user-email verifications for buying meezacredit*/}
      <Modal
        AnimationType="slide"
        visible={showWalletScreen}
        onRequestClose={() => setShowWalletScreen(false)}
      >
        <WalletScreen
          hideModal={() => setShowWalletScreen(false)}
          setHasDva={setDVAStatus}
          setIsVerified={setIsVerified}
          isVerified={isVerified}
        />
      </Modal>

      <Modal
        AnimationType="slide"
        visible={showVerifiedCustomer}
        onRequestClose={() => setShowVerifiedCustomer(false)}
      >
        <TopHeaderComponent
          headerText={"Verification"}
          hideScreen={() => setShowVerifiedCustomer(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            <VerifiedCustomer
              hideScreen={() => {
                setShowVerifiedCustomer(false);
              }}
              setHasDva={setDVAStatus}
            />
          </View>
        </ScrollView>
      </Modal>

      <Modal
        AnimationType="slide"
        visible={showWalletBalanceScreen}
        onRequestClose={() => setShowWalletBalanceScreen(false)}
      >
        <TopHeaderComponent
          headerText={"My Wallet"}
          hideScreen={() => setShowWalletBalanceScreen(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            <WalletBalanceScreen setShowWalletBalanceScreen={setShowWalletBalanceScreen} />
          </View>
        </ScrollView>
      </Modal>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Modal visible={showWordNotice} transparent={true} animationType="fade">
        <WordNotice
          message={wordMessage}
          onClose={() => setShowWordNotice(false)}
          tagLink={celebrateMeLink}
          title={"Celebrate Me"}
        />
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: width * 0.04, // 4% of screen width
    backgroundColor: "white",
  },

  profileCelebrateMe: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: dynamicSpacing(20),
    // paddingTop: height * 0.03, // 3% of screen height
    //  gap: width * 0.02,
  },
  celebrateMeStyles: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(3),
  },
  profileContainer: {
    flexDirection: "row",
    alignItems: "center",
    // paddingTop: dynamicSpacing(20),
    // paddingTop: height * 0.03, // 3% of screen height
    gap: width * 0.02,
  },

  userImage: {
    width: width * 0.12, // 12% of screen width
    height: width * 0.12, // Keep square
    borderRadius: 99,
  },
  welcomeText: {
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
    // fontSize: Fonts.small,
    fontSize: dynamicFontSize(12),
  },
  nameText: {
    // fontSize: Fonts.large,
    fontSize: dynamicFontSize(20),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
  },
  nameText2: {
    // fontSize: Fonts.large,
    fontSize: dynamicFontSize(14),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: height * 0.03,
  },
  buttonContainer2: {
    display: "flex",
    justifyContent: "center",
    //flexDirection: "row",
    // justifyContent: 'space-between',
    alignItems: "center",
    paddingTop: height * 0.03,
    //backgroundColor: "green",
  },
  button: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: width * 0.03, // Responsive border radius
    // width: '100%',

    width: width * 0.91, // 90% of screen width
    height: height * 0.08, // 7% of screen height
    backgroundColor: Colours.PRIMARY,
  },
  buttonText: {
    color: "white",
    fontFamily: "Sen-Bold",
    // fontSize: Fonts.medium,
    fontSize: dynamicFontSize(16),
  },
  transferFromContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    marginTop: height * 0.025, // 2.5% of screen height
    padding: width * 0.04,
    borderRadius: width * 0.04,
  },
  quickAccessText: {
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
    // fontSize: Fonts.medium,
    fontSize: dynamicFontSize(14),
  },
  topUpButtons: {
    flexDirection: "row",
    gap: width * 0.04,
  },
  topUpText: {
    width: width * 0.13, // 13% of screen width
    height: width * 0.13,
    // borderRadius: width * 0.065,
    // borderWidth: 1,
    borderColor: Colours.PRIMARY,
    alignItems: "center",
    justifyContent: "center",
  },
  topUpButtonText: {
    color: "white",
    // fontSize: Fonts.small,
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Regular",
  },
  fab: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(30),
    backgroundColor: Colours.PRIMARY,
    justifyContent: "center",
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    // zIndex: 10, // Ensures it floats above other content
  },
  fab1: {
    display: "flex",
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(30),
    backgroundColor: Colours.DARKGRAY,
    justifyContent: "center",
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    // zIndex: 10, // Ensures it floats above other content
  },
  fab6: {
    display: "flex",
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: dynamicSize(30),
    backgroundColor: Colours.DARKGREEN,
    justifyContent: "center",
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    // zIndex: 10, // Ensures it floats above other content
  },
  fabText: {
    color: "#fff",
    fontSize: dynamicFontSize(30),
    fontWeight: "bold",
  },

  // === NEW SLIM DESIGN FOR LIST OF RECENT TABLES ===
  activeTablesSection: {
    marginTop: dynamicSpacing(24),
  },
  sectionHeadingText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(13),
    color: "#666",
    letterSpacing: 0.5,
    marginBottom: dynamicSpacing(12),
  },
  tableSlimRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FAFAFA",
    borderWidth: 1,
    borderColor: "#EAEAEA",
    borderRadius: dynamicSize(12),
    paddingVertical: dynamicSpacing(10),
    paddingHorizontal: dynamicSpacing(14),
    marginBottom: dynamicSpacing(8),
  },
  tableMetaBlock: {
    flex: 1,
    paddingRight: dynamicSpacing(10),
  },
  slimTableName: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
    color: Colours.DARKGRAY,
    marginBottom: dynamicSize(1),
  },
  slimBrandName: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: "gray",
  },
  slimCheckBillBtn: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colours.PRIMARY,
    paddingVertical: dynamicSpacing(10),
    paddingHorizontal: dynamicSpacing(12),
    borderRadius: dynamicSize(15),
    gap: dynamicSpacing(2),
  },
  slimCheckBillBtnText: {
    color: "white",
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(12),
  },
  emptyActiveTables: {
    paddingVertical: dynamicSpacing(20),
    alignItems: "center",
    justifyContent: "center",
  },
  emptyTablesText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(13),
    color: "#AAA",
  },

  statusBadge: {
    flexDirection: "row",
    alignItems: "center",
  },

  statusContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(5),
    borderRadius: dynamicSize(20),
    backgroundColor: "#E7F9ED",
  },
  statusDot: {
    width: dynamicSize(7),
    height: dynamicSize(7),
    borderRadius: dynamicSize(4),
    marginRight: dynamicSpacing(6),
  },
  statusText: {
    fontSize: dynamicFontSize(11),
    fontFamily: "Sen-Bold",
  },
});
